<div class="question-container">
  <mat-expansion-panel [disabled]="!enabled" [attr.disabled]="!enabled" [class.completed]="question.Completed || expanded"
    [class.incompleted]="!question.Completed && !expanded" [expanded]="expanded" class="question-panel"
    [hideToggle]="true" (opened)="openPanel()" (closed)="expanded = false">
    <mat-expansion-panel-header collapsedHeight="auto" expandedHeight="auto" class="question-head">
      <mat-panel-title class="question-head-title">
        <p class="question-head-title expanded" *ngIf="expanded && showNumber" [attr.data-Id]="getQuestionIndexId(index)">
          {{ index + 1 }}/{{ total }}
        </p>
        <p class="question-head-title collapsed" *ngIf="!expanded" [innerHTML]="question.QuestionText" [attr.data-Id]="question.Title"></p>
        <p class="question-head-subtitle expanded" *ngIf="expanded" [innerHTML]="question.QuestionText" [attr.data-Id]="question.Title"></p>
        <h4 class="question-head-subtitle collapsed" *ngIf="!expanded && question.Answer && question.Answer.AnswerText" [attr.data-Id]="question.Title">
          {{ question.Answer.AnswerText }}
        </h4>
        <div *ngIf="question.errorMessage && !expanded" class="mat-error collapse-question-error">
          {{question.errorMessage}}
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div *ngIf="question" class="questionChoices">
      <mat-radio-group [disabled]="!enabled"  (change)="selectionChanged($event)" class="demands-radio-group" [formControl]="questionsFormControl">
        <mat-radio-button #button class="mr-5"*ngFor="let choice of question.Choices" [value]="choice.AnswerText" (click)="checkState(button)" [attr.data-id]="getRadioButtonId(choice.AnswerText)">
          {{ choice.AnswerText }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
    <div *ngIf="question.errorMessage" class="mat-error">
      {{question.errorMessage}}
    </div>
  </mat-expansion-panel>
</div>